import { render, staticRenderFns } from "./CodeDialog.vue?vue&type=template&id=f55dbd46&scoped=true"
import script from "./CodeDialog.vue?vue&type=script&lang=js"
export * from "./CodeDialog.vue?vue&type=script&lang=js"
import style0 from "./CodeDialog.vue?vue&type=style&index=0&id=f55dbd46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55dbd46",
  null
  
)

export default component.exports